import { render, staticRenderFns } from "./medical-form.vue?vue&type=template&id=4481a0c0&scoped=true&"
import script from "./medical-form.vue?vue&type=script&lang=js&"
export * from "./medical-form.vue?vue&type=script&lang=js&"
import style0 from "./medical-form.vue?vue&type=style&index=0&id=4481a0c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4481a0c0",
  null
  
)

export default component.exports